export default __webpack_public_path__ + "static/media/garden-05.1275fc0b.jpg";